//#region types
import { ReconciliationStatusProps } from "models/propTypes/accountingPropTypes";
//#endregion
//#region components
//#endregion
import clsx from "clsx";
import cssExports from "theme/styles/main.module.scss";

const ReconciliationStatus: React.FC<ReconciliationStatusProps> = (props) => {
  return (
    <div
      className={clsx(
        cssExports.reconciliationReportStatus,
        props.isChecked ? cssExports.checked : cssExports.unChecked
      )}
    />
  );
};

export default ReconciliationStatus;
